"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverflowDropdown = void 0;
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var theme_1 = require("../../theme");
var styled_1 = require("../../styled");
var Toggle_1 = require("../Toggle");
var OverflowDropdown = function (_a) {
    var children = _a.children, _b = _a.disabled, disabled = _b === void 0 ? false : _b, onClick = _a.onClick;
    return (React.createElement(Toggle_1.Toggle, null, function (_a) {
        var on = _a.on, toggle = _a.toggle;
        return (React.createElement(semantic_ui_react_1.Popup, { position: "bottom right", trigger: React.createElement(semantic_ui_react_1.Button, { className: "popupTrigger", floated: "right", circular: true, disabled: disabled, style: { background: theme_1.colors.white }, icon: React.createElement(DropdownIcon, { src: require('../../../assets/overflow.svg') }), onClick: function (e) {
                    e.stopPropagation();
                    if (typeof onClick === 'function') {
                        onClick();
                    }
                    toggle();
                } }), open: on },
            React.createElement("span", { onClick: function (e) {
                    toggle();
                } }, children)));
    }));
};
exports.OverflowDropdown = OverflowDropdown;
var DropdownIcon = styled_1.default.img(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 20px;\n  height: 20px;\n  opacity: 0.25;\n\n  &:active {\n    opacity: 1;\n  }\n"], ["\n  width: 20px;\n  height: 20px;\n  opacity: 0.25;\n\n  &:active {\n    opacity: 1;\n  }\n"])));
var templateObject_1;
//# sourceMappingURL=index.js.map